//? Commented code is to show city score in detail's cities cards or to blur the city score

import { useEffect, useState } from "react"
import { CONNECTIVITY_TRAVEL, GOVERNMENT_LANDSCAPE } from "./utils.js"

export default function CityCard({ city, cityResults, variable }) {
// export default function CityCard({ city }) {
    const [specialClass, setSpecialClass] = useState("")

    useEffect(() => {
        if (!variable) return

        setSpecialClass(() => {
            return variable?._id?.toString() === CONNECTIVITY_TRAVEL || variable?._id?.toString() === GOVERNMENT_LANDSCAPE
        })
    }, [variable])
    
    const scoreClass = cityResults?.cost && cityResults?.score === 3 ? "blueScore" : ""
    const dataToShow = specialClass ? "#" : cityResults?.cost !== null ? cityResults?.score : "N/A"

    return (
        <div className="cityScoreCard">
            <div className="cityNameContainer">
                <h5 className="cityName">{city.municipality_name}</h5>  
                <span>City</span>
            </div>
            <h5 
                // className="score"
                className={`score ${scoreClass}`}
                style={specialClass ? {filter: "blur(18px)"} : {}}
                // style={{filter: "blur(18px)"}}
            >
                {/* # */}
                {dataToShow}
            </h5>
            <span>Rate</span>
        </div>
    )
}
